import type { JSX } from 'solid-js';
import { Show } from 'solid-js';
import { Button, buttonClass } from './ui/Button';

// Empty state (spec §3.15): plain centered muted text, optional icon + CTA.

export type EmptyStateProps = {
  readonly message: string;
  readonly icon?: JSX.Element;
  readonly ctaLabel?: string;
  readonly ctaHref?: string;
  /** In-app CTA (#619): renders the CTA as a button instead of a link. */
  readonly onCta?: () => void;
};

export function EmptyState(props: EmptyStateProps): JSX.Element {
  return (
    <div class="empty-state" role="status">
      <Show when={props.icon}>
        <div class="empty-state__icon" aria-hidden="true">
          {props.icon}
        </div>
      </Show>
      <p class="empty-state__message">{props.message}</p>
      <Show when={props.ctaLabel && props.ctaHref}>
        <a class={buttonClass({ variant: 'outline', size: 'sm' })} href={props.ctaHref}>
          {props.ctaLabel}
        </a>
      </Show>
      <Show when={props.ctaLabel && props.onCta}>
        <Button variant="outline" size="sm" onClick={() => props.onCta?.()}>
          {props.ctaLabel}
        </Button>
      </Show>
    </div>
  );
}
